import { Model } from "@root/data/lib";
import { IAHSourceRepositoryLite } from "@root/data/build";
import { computed } from "mobx";
import { truncate } from "lodash";
import { relativeDate } from "@root/lib/utils/time";

export interface SerializedGitHubRepo extends Partial<IAHSourceRepositoryLite> {
  default_branch: string;
  updated_at: string;
  language?: string;
  fork: boolean;
}

export interface DeserializedGitHubRepo extends Partial<IAHSourceRepositoryLite> {
  updatedAt: Date;
  cloneURL: string;
  defaultBranch: string;
  ownerName: string;
  ownerAvatarURL: string;
  language?: string;
  fork: boolean;
}

export class GitHubRepo extends Model<DeserializedGitHubRepo> implements DeserializedGitHubRepo {
  public id!: string;
  public name!: string;
  public description!: string;
  public updatedAt!: Date;
  public cloneURL!: string;
  public defaultBranch!: string;
  public ownerName!: string;
  public ownerAvatarURL!: string;
  public language?: string;
  public fork!: boolean;
  public private!: boolean;
  @computed get relativeDate() {
    return relativeDate(this.updatedAt, true);
  }
  @computed get shortDescription() {
    return truncate(this.description, {
      length: 120,
      omission: "…",
      separator: /[^\w]/,
    });
  }
}
